;delta.reportFEColumnEdit = function () {
    var

    _report_id = null,

    //these are set after the popup is opened
    _column_id = null,
    _original_column_name = null,

    _$columnName = null,
    _$addIndividual = null,  //both radio buttons
    _$filters = null,        //all dimension checkboxes
    _$dimListContainer = null,
    _$positionText = null,   //the position item text elem for this field
    _$positoinTabButton = null,

    //set if column name was just deleted
    _column_name_cleared = false,

    
    //
    // init, called from report.js
    //
    init = function(report_id) {
        //save the report id
        _report_id = report_id;

        setupAdd();
        setupEdit();
        

    },


    //
    // setup the FE Add Dimension Columns links
    //
    setupAdd = function() {
        $(document).on('click', '.column-add-fe', function() {
            var $addButton = $(this).closest('.dropdown-menu').prev('.column-add-a');
            var $spinner = $("#column-add-image-loading");

            showModal($addButton, $spinner, null);

            return false;
        });
    },

    //
    // setup the FE Edit Column links
    //
    setupEdit = function() {
        $(document).on('click', '.column-edit-fe', function() {
            var $editButton = $(this);
            var $spinner = $(this).siblings('.column-map-spinner');
            var columnID = $editButton.attr('data-column-id');
            var columnName = $editButton.attr('data-column-name');

            showModal($editButton, $spinner, columnID);

            return false;
        });
    },

    //
    // show the FE Map Dimensions to Column popup
    //
    showModal = function($addEditButton, $spinner, columnID, columnName) {
        //hide the add/edit button & show the spinner
        $addEditButton.hide();
        $spinner.show();

            //call the controller & get the popup
            delta.ajax.get(
                `/report/FEColumnEdit?reportID=${_report_id}&columnID=${columnID}`,
                function (html) {
                    delta.popup.open({
                        type: 'confirm',
                        title: (columnID == null ? 'Add Dimension Column' : 'Map Dimensions to Column'),
                        content: html,
                        cssClass: 'modal-lg modal-fe-column-edit',
                        afterOpen: function ($popup) {
                            //hide the spinner & restor the Add button
                            $spinner.hide();
                            $addEditButton.show();

                            //get the elements we need to work with
                            getElements($popup);
                            setupModal($popup);
                        },
                        okCallback: function ($popup) {
                            if (isValid()) {
                                //get the post data
                                var $body = $popup.find('.modal-body');

                                var formData = new FormData();
                                formData.append('ReportID', _report_id);
                                formData.append('ColumnGuid', _column_id);
                                formData.append('ColumnName', _$columnName.val());
                                formData.append('AddIndividualColumns', _$addIndividual.filter(':checked').val());

                                _$filters.filter(':checked:not(:disabled)').each(function() {
                                    formData.append('SelectedDimensions', $(this).val());
                                });

                                $body.find('.column-position-item').each(function() {
                                    if ($(this).attr('data-column-id')) {
                                        formData.append('ColumnPositions', $(this).attr('data-column-id'));
                                    } else {
                                        //placeholder for new column
                                        formData.append('ColumnPositions', '00000000-0000-0000-0000-000000000000');
                                    }
                                });

                                // Show spinner & disable the ok button
                                showSpinner($popup);

                                //post the data
                                delta.ajax.postFormData(
                                    '/report/FEColumnEdit',
                                    formData,
                                    function() {
                                        location.reload();
                                    }
                                );
                            } else {
                                setTimeout(function() {
                                    delta.popup.enableButtons($popup);
                                }, 50);
                                
                            }

                            return false; //keep it open
                        }
                    });
                }
            );


    },


    //
    // get the elements we need to deal with from the popup
    //
    getElements = function($popup) {
        //get the popup body
        var $body = $popup.find('.modal-body');

        //get our column id
        _column_id = $body.find('#ColumnGuid').val();
        
        //get the elements
        _$columnName = $body.find('#ColumnName');
        _$addIndividual = $body.find('[name=AddIndividualColumns]');
        _$filters = $body.find('[name=filters');
        _$dimListContainer = $body.find('.dimension-list');
        _$positionText = $body.find('li.column-position-item.border-primary h6');
        _$positoinTabButton = $body.find('#nav-position-tab');

        //original column name for delete prompt
        _original_column_name = _$columnName.val();
    },


    //
    // setup the edit column popup after it's open
    //
    setupModal = function($popup) {
        setupColumnName();
        setupFilterChecks();
        setupAddAsIndividual();
        setupPosition($popup);
        setupDeleteButton($popup);

        //update the ui for validations
        updateUI();
    },


    //
    // setup the column name text box
    //
    setupColumnName = function() {
        _$columnName.on('keyup change', function() {
            if (!$(this).val()) {
                //set the flag saying we just cleared the column name
                _column_name_cleared = true;
            }
            updateUI();
        });
    },

    //
    // setup the filter check boxes
    //
    setupFilterChecks = function() {
        _$filters.on('change', function() {
            updateUI();
        });
    },

    //
    // setup the add as individual/single column radios
    //
    setupAddAsIndividual = function() {
        _$addIndividual.on('change', function() {
            updateUI();
        });
    },

    //
    // Update the UI based on the current state of the controls
    //
    updateUI = function() {
        // var columnNameText = _$columnName.val();
        var columnNameDisabled = _$columnName.is(':disabled');
        var addIndividual = _$addIndividual.filter(':checked').val() === 'true';

        //If we just set add individual, save the original column name & change to N/A
        if (addIndividual && !columnNameDisabled) {
            _original_column_name = _$columnName.val();
            _$columnName.val('N/A');
        }

        //if we just turned off add individual, restore the original column name
        if (!addIndividual && columnNameDisabled) {
            _$columnName.val(_original_column_name);
        }

        //if empty column name, set to first checked item, unless the user just cleared it
        if (!addIndividual && !_$columnName.val() && !_column_name_cleared) {
            var $chk = _$filters.filter(':checked:not(:disabled)').first();
            if ($chk.length > 0) {
                var text = $chk.next('label').find('span').text();
                _$columnName.val(text);
            }
        }

        //reset flag
        _column_name_cleared = false;



        //update the column name in the position
        if (!addIndividual) {
            _$positionText.html(_$columnName.val());
        }

        //column name validation
        if (_$columnName.val()) {
            _$columnName.removeClass('is-invalid');
        } else {
            _$columnName.addClass('is-invalid');
        }

        //dimension list validation
        if (_$filters.filter(':checked:not(:disabled)').length > 0) {
            _$dimListContainer.removeClass('is-invalid');
        } else {
            _$dimListContainer.addClass('is-invalid');
        }

        //add individual/single column radios
        if (_$addIndividual.filter(':checked').val() === 'true') {
            //add as individual columns, disable column name
            _$columnName.prop('disabled', true);
            _$positoinTabButton.prop('disabled', true);
        } else {
            //map dimensions to single column, enable column name
            _$columnName.prop('disabled', false);
            _$positoinTabButton.prop('disabled', false);
        }
    },

    setupPosition = function($popup) {
        var $body = $popup.find('.modal-body');

        $body.find("#column-position-sortable").sortable({
            axis: "x",
            containment: "parent",
            items: "li:not(.non-sortable)", // Prevent total column from being sorted
            update: function (event, ui) {
                // Always ensure Total column is last after any sorting operation
                var $totalCol = $body.find('#column-position-sortable li.non-sortable');
                if ($totalCol.length > 0) {
                    $body.find("#column-position-sortable").append($totalCol);
                }
            }
        });

        // scroll to show our new position item
        $body.find('#nav-position-tab').off('shown.bs.tab').on('shown.bs.tab', function (e) {
            var $li = $body.find('li.column-position-item.border-primary');
            $li[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        });
    },


    //
    // setup the delete button if there is a column id
    //
    setupDeleteButton = function($popup) {
        if (_column_id) {
            $popup.find('.modal-footer').prepend(
                `<button type="button" class="btn btn-danger delete-column-btn float-start">Delete</button>`
            );

            //delete button handler
            $popup.on('click', '.delete-column-btn', function() {
                delta.popup.open({
                    type: 'confirm',
                    title: 'Delete Column',
                    content: `Are you sure you want to delete the column "<b>${_original_column_name}</b>"?`,
                    okButtonText: 'Yes, Delete',
                    afterOpen: function ($popup) {
                        $popup.find('.modal-footer .btn-primary')
                            .removeClass('btn-primary')
                            .addClass('btn-danger');
                    },
                    okCallback: function ($popup2) {
                        //show spinner & disable buttons
                        showSpinner($popup2);

                        //call controller to delete it
                        delta.ajax.get(
                            `/report/FEColumnDelete?reportID=${_report_id}&columnID=${_column_id}`,
                            function() {
                                //reload the page
                                location.reload();
                            }                        
                        )

                        return false;
                    }
                });
                
            });

        }
    },

    //
    // see if we are valid
    //
    isValid = function(){
        var addIndividual = (_$addIndividual.filter(':checked').val() === 'true');
        var columnNameText = _$columnName.val();
        var filters = (_$filters.filter(':checked:not(:disabled)').length > 0);

        if (filters && (columnNameText || addIndividual)) {
            return true;
        } else {
            return false;
        }
    },

    //
    // show the spinner & disable the buttons
    //
    showSpinner = function ($popup) {
        $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
        $popup.find('.modal-footer button').prop('disabled', true);
    },


    dummy = function () { };

    return {
        init: init
    };
}();